module.exports = __webpack_public_path__ + "img/3.87372d53.jpg";